@if (visible) {
  <span class="audit-stamp-item">
    @if (showIcons) {
      <i class="pi pi-user-plus" aria-hidden="true"></i>
    }
    <span class="audit-stamp-label">{{ labelCreate }}:</span>
    <strong class="audit-stamp-user" [title]="userNameCreate || null">{{ userNameCreate || emptyText }}</strong>
    <span class="audit-stamp-date">
      @if (createDate) {
        {{ createDate | date: dateFormat }}
      } @else {
        {{ emptyText }}
      }
    </span>
  </span>

  @if (showUpdate) {
    <span class="audit-stamp-sep" aria-hidden="true">·</span>
    <span class="audit-stamp-item">
      @if (showIcons) {
        <i class="pi pi-user-edit" aria-hidden="true"></i>
      }
      <span class="audit-stamp-label">{{ labelUpdate }}:</span>
      <strong class="audit-stamp-user" [title]="userNameUpdate || null">{{ userNameUpdate || emptyText }}</strong>
      <span class="audit-stamp-date">
        @if (updateDate) {
          {{ updateDate | date: dateFormat }}
        } @else {
          {{ emptyText }}
        }
      </span>
    </span>
  }
} @else if (reserving) {
  <!-- Sin contenido visible: solo reserva el alto de una línea del sello. -->
  <span class="audit-stamp-item audit-stamp-ghost" aria-hidden="true">
    @if (showIcons) {
      <i class="pi pi-user-plus"></i>
    }
    <span class="audit-stamp-label">{{ labelCreate }}:</span>
    <strong class="audit-stamp-user">&#8203;</strong>
  </span>
}
